import { Modal } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { Button } from "../../../components";
import { FormInput, FormSelect } from "../../../components/forms";
import { Spinner } from "../../../components/loaders";
import { ErrorMessage, ErrorMessageWrapper } from "../../../components/messages";
import useCreateClientSet from "../hooks/useCreateClientSet";
import ThemedModal from "../../../components/utilities/ThemedModal";

const CreateClientSetModal = ({
    handleClose,
    ...modalProps
}) => {
    const {
        create,
        reset,
        control,
        setValue,
        clientSets,
        isFetching,
        isError,
        error,
        refetch,
        errors
    } = useCreateClientSet({ handleClose });

    const onHide = () => {
        reset();
        handleClose();
    }

    return <Modal centered onHide={onHide} size="md" {...modalProps}>
        <ThemedModal.Header closeButton>
            <Modal.Title>Create Client Set</Modal.Title>
        </ThemedModal.Header>
        <form onSubmit={create}>
            <Modal.Body>
                {isFetching
                    ? <Spinner className="m-auto" />
                    : isError
                        ? <ErrorMessageWrapper>
                            <ErrorMessage
                                message={error?.data?.message ?? error?.data ?? "Failed to load client sets."}
                                retryCallback={refetch}
                            />
                        </ErrorMessageWrapper>
                        : <div className="row gx-3 pb-2">
                            <span className="col-12">
                                <Controller
                                    control={control}
                                    name="name"
                                    rules={{ required: "Please enter a name for the new set" }}
                                    render={({ field: { onChange, value, ...props } }) =>
                                        <FormInput
                                            {...props}
                                            parentClassName="pb-2"
                                            label="New Set Name:"
                                            onChange={(e) => setValue("name", e.target.value)}
                                            disableAnimations
                                            errorMessage={errors?.name?.message}
                                            errorAllowRetry={false}
                                        />
                                    }
                                />
                            </span>
                            <span className="col-12">
                                <Controller
                                    control={control}
                                    name="baseSetId"
                                    render={({ field: { onChange, value, ...props } }) =>
                                        <FormSelect
                                            {...props}
                                            label="Select a Set to start from (optional):"
                                            options={clientSets}
                                            defaultValue={value}
                                            onChange={(selection) => {
                                                setValue("baseSetId", selection.value);
                                            }}
                                            disableAnimations
                                            isClearable
                                        />
                                    }
                                />
                            </span>
                        </div>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" type='submit'>Create Set</Button>
                <Button variant="light" onClick={onHide}>Cancel</Button>
            </Modal.Footer>
        </form>
    </Modal>
}

export default CreateClientSetModal;